var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory, SurveyElementBase } from "survey-react-ui";
import { SurveyCreatorToolboxTool } from "./ToolboxItem";
var ToolboxList = /** @class */ (function (_super) {
    __extends(ToolboxList, _super);
    function ToolboxList(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(ToolboxList.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ToolboxList.prototype, "creator", {
        get: function () {
            return this.props.creator;
        },
        enumerable: false,
        configurable: true
    });
    ToolboxList.prototype.getStateElement = function () {
        return this.model;
    };
    ToolboxList.prototype.render = function () {
        if (!this.model || !this.model.renderElements)
            return null;
        var items = this.renderItems();
        return (React.createElement("div", { className: this.model.cssClasses.root }, items));
    };
    ToolboxList.prototype.renderItems = function () {
        var _this = this;
        var items = this.model.renderedActions;
        return items.map(function (item, itemIndex) {
            return React.createElement(SurveyCreatorToolboxTool, { item: item, creator: _this.creator, parentModel: _this.model, isCompact: false, key: "item" + itemIndex });
        });
    };
    return ToolboxList;
}(SurveyElementBase));
export { ToolboxList };
ReactElementFactory.Instance.registerElement("svc-toolbox-list", function (props) {
    return React.createElement(ToolboxList, props);
});
